<template>
  <div class="dashboard-content-wrapper">
    <!-- Overlay durante el switch de negocio: evita el flash blanco
         entre que se desmonta el componente viejo y se renderiza el
         skeleton del nuevo. Visible solo mientras dura el request a
         /business/selected (controlado por requestLoading). -->
    <transition name="biz-switch-fade">
      <div v-if="switching" class="biz-switch-overlay">
        <div class="biz-switch-spinner">
          <div class="biz-switch-dot"></div>
          <div class="biz-switch-dot"></div>
          <div class="biz-switch-dot"></div>
        </div>
        <span class="biz-switch-label">Cargando negocio…</span>
      </div>
    </transition>
    <TransitionFadeComponent>
      <!--
        :key reactivo al business id: cuando el usuario cambia de negocio,
        Vue ve una key diferente y desmonta/remonta todo el subárbol del
        dashboard. Sin esto, los componentes con state interno (caches en
        DashboardKpis, listas cargadas en Documents, etc.) seguían mostrando
        datos del negocio anterior.
      -->
      <router-view :key="businessKey" class="content"></router-view>
    </TransitionFadeComponent>
  </div>
</template>

<script>
import TransitionFadeComponent from "@/components/Transitions/Fade";

export default {
  name: "DashboardContentComponent",
  components: {
    TransitionFadeComponent
  },
  data() {
    return {
      switching: false
    };
  },
  computed: {
    businessKey() {
      const user = this.$store.getters.getUser;
      return (user && user.user_business && user.user_business.id) || 0;
    }
  },
  watch: {
    // Cuando el id cambia, mostrar el overlay un instante mientras los
    // componentes hijos remontan y disparan sus fetches iniciales.
    businessKey(newId, oldId) {
      // Skip si es el primer render (oldId === undefined) o no hay cambio real
      if (oldId === undefined || newId === oldId) return;
      this.switching = true;
      // Permitir 2 ticks para que router-view renderice el skeleton del
      // nuevo componente, luego ocultar el overlay para revelarlo.
      this.$nextTick(() => {
        setTimeout(() => {
          this.switching = false;
        }, 400);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard-content-wrapper {
  position: relative;
  min-height: 100vh;
}
.biz-switch-overlay {
  position: fixed;
  inset: 60px 0 0 0; /* respeta el header sticky */
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(2px);
  z-index: 900;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
.biz-switch-spinner {
  display: flex;
  gap: 6px;
}
.biz-switch-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #3fdbbf;
  animation: biz-bounce 1.2s infinite ease-in-out both;
  &:nth-child(1) {
    animation-delay: -0.32s;
  }
  &:nth-child(2) {
    animation-delay: -0.16s;
  }
}
.biz-switch-label {
  font-size: 13px;
  color: #31355c;
  font-weight: 600;
  letter-spacing: 0.2px;
}
@keyframes biz-bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.biz-switch-fade-enter-active,
.biz-switch-fade-leave-active {
  transition: opacity 0.18s;
}
.biz-switch-fade-enter,
.biz-switch-fade-leave-to {
  opacity: 0;
}
</style>
